import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateFeatureFlag } from "services";

import { GET_ALL_FEATURE_FLAGS, GET_CARBON_PROGRAM_FEATURE_FLAGS, GET_FARM_FEATURE_FLAGS, UPDATE_FEATURE_FLAG } from "consts";

export const useUpdateFeatureFlag = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [UPDATE_FEATURE_FLAG],
    mutationFn: updateFeatureFlag,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_ALL_FEATURE_FLAGS] });
      queryClient.invalidateQueries({ queryKey: [GET_FARM_FEATURE_FLAGS] });
      queryClient.invalidateQueries({ queryKey: [GET_CARBON_PROGRAM_FEATURE_FLAGS] });
    },
  });
};
